import { Card, Avatar, Tag } from 'antd';
import {
    BugOutlined,
    CalendarOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import { getInitials } from '../../../../../utils/helper';
import CommonCardView from '../../../../global/cardView';

const ScrappingErrorCard = ({ record, onClick }) => {
    const initials = getInitials(record.userEmail || "U");

    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onClick && onClick(record)}
        >
            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate" title={record.userEmail}>
                                {record.userEmail || "N/A"}
                            </h3>
                            <p className="text-gray-500 text-sm mb-0 truncate">
                                Scrapping Error
                            </p>
                        </div>
                    </div>
                </div>

                {/* Info Section */}
                <div className="space-y-3">
                    {/* Lead Source */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            <InfoCircleOutlined className="mr-1" />
                            Lead Source:
                        </span>
                        <Tag color="blue" className="capitalize">
                            {record.leadSource}
                        </Tag>
                    </div>

                    {/* Error Message */}
                    <div className="flex flex-col space-y-1">
                        <span className="text-sm text-gray-600 font-medium">
                            <BugOutlined className="mr-1" />
                            Error:
                        </span>
                        <div className="text-sm text-gray-700  truncate max-w-full" title={record.error}>
                            {record.error ?? "-"}
                        </div>
                    </div>

                    {/* DateTime */}
                    <div className="flex items-center justify-between border-t border-gray-200 pt-3">
                        <span className="text-sm text-gray-600 font-medium">
                            <CalendarOutlined className="mr-1" />
                            Date Time:
                        </span>
                        <span className="text-sm text-gray-700">
                            {record.createdAt}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

const EnhancedScrappingErrorsGridView = ({ data, onRowClick }) => {
    return (
        <CommonCardView>
            {data.map((record) => (
                <ScrappingErrorCard
                    key={record.key}
                    record={record}
                    onClick={onRowClick}
                />
            ))}
        </CommonCardView>
    );
};

export default EnhancedScrappingErrorsGridView;